import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import { widgetListSettings } from "./widgetSettings.js";
import InspectionSummaryWidgetContainer from "./widgets/InspectionSummaryWidget";
import InspectionListWidgetContainer from "./widgets/InspectionListWidget";
import MaintenanceListWidgetContainer from "./widgets/MaintenanceListWidget/MaintenanceListWidget.jsx";
import ExecutionListWidget from "./widgets/ExecutionListWidget/ExecutionListWidget.jsx";
import SelectField from "../../libraries/form/formField/fields/SelectField";
import MenuFilter from "components/Common/MenuFilters/index";
import WOActivityWidgetContainer from "./widgets/workOrderActivityWidget.jsx";
import GroupedBarChart from "./widgets/barGraphWidget/Chart.jsx";
import BarGraphSummaryWidgetContainer from "./widgets/barGraphWidget/BarGraphSummaryWidget.jsx";
import MonthYearPicker from "../Common/Calendar/MonthYearPicker.jsx";
import { themeService } from "../../theme/service/activeTheme.service.js";
import { DashboardPageStyle } from "../Dashboard/styles/DashboardPageStyle.js";
import { languageService } from "../../Language/language.service.js";

//TODO remove un used widgets
const widgetComponentLookup = {
  inspectionSummaryWidget: InspectionSummaryWidgetContainer,
  inspectionsList: InspectionListWidgetContainer,
  maintenanceList: MaintenanceListWidgetContainer,
  executionsList: ExecutionListWidget,
  workOrderStatusSummaryWidget: WOActivityWidgetContainer,
  BarGraphSummaryWidget: BarGraphSummaryWidgetContainer,
};

class NewDashboard extends Component {
  constructor(props) {
    super(props);
    const now = new Date();
    const currentMonthName = now.getMonth() + 1;
    this.state = {
      filterLocations: null,
      selectedDateRange: {
        month: currentMonthName,
        year: String(now.getFullYear()),
      },
    };
    this.filterLocations = this.filterLocations.bind(this);
  }

  filterLocations(locations) {
    const filtered = locations.filter((loc) => loc.state).map((loc) => loc.id);
    this.setState({ filterLocations: filtered });
  }

  handleDateChange = (newDate) => {
    const monthNumber = newDate.getMonth() + 1;
    const monthName = newDate.toLocaleString("default", { month: "long" });
    const year = newDate.getFullYear();
    this.setState({
      selectedDateRange: {
        month: monthNumber,
        year: String(year),
      },
    });
  };

  render() {
    const { selectedDateRange, filterLocations } = this.state;

    return (
      <Col md={12} className="mainContent">
        <MenuFilter
          menuFilterApplied={(assetChildren, options) => {
            this.filterLocations(assetChildren);
          }}
          handelMenuClickData={(assetChildren, displayMenuAll, lineNames) => {
            this.filterLocations(assetChildren);
          }}
          displayMenuAll={true}
          dataLoadedCallback={() => {}}
        />

        <Row
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "15px",
            paddingLeft: "15px",
            gap: "10px",
            flexWrap: "wrap",
          }}
        >
          <div style={{ ...themeService(DashboardPageStyle.headingRow), marginBottom: 0 }}>{languageService("Dashboard Summary")}</div>
          <MonthYearPicker onChange={this.handleDateChange} />
        </Row>

        {filterLocations && (
          <Row>
            {widgetListSettings

              .sort((a, b) => a.order - b.order)
              .map((e) => {
                const WidgetComponent = widgetComponentLookup[e.widgetId];
                return (
                  WidgetComponent && (
                    <Col key={e.widgetId} md={e.colspan} style={{ padding: 15 }}>
                      <WidgetComponent settings={e} dateRange={selectedDateRange} filterLocations={filterLocations} />
                    </Col>
                  )
                );
              })}
          </Row>
        )}
      </Col>
    );
  }
}

export default NewDashboard;



// WEBPACK FOOTER //
// ./src/components/NewDashboard/NewDashboard.jsx